/**
 * External Imports
 */
import { FC, useState, useEffect, useMemo } from 'react';

/**
 * Internal Imports
 */
import AddIssueFromRound from '../shared/buttons/AddIssueFromRound';
import AddFbFromRoundBtn from '../shared/buttons/AddFeedbackFromRound';
import CancelRoundBtn from '../shared/buttons/CancelRound';
import CompleteRoundBtn from '../shared/buttons/CompleteRound';

/**
 * Global Type Definition Imports
 */
import { Patient, Employee } from '../../config/interfaces';

/**
 * Style Imports
 */
import { StickyFooter } from './Round.styles';

const RoundFooter: FC<{
  isEdit: boolean;
  hasChanges: boolean;
  selectedEmployee?: Employee | null;
  selectedPatient?: Patient | null;
  type: string;
}> = ({ isEdit, hasChanges, selectedEmployee, selectedPatient, type }) => {
  const [actualPatientData, setActualPatientData] = useState<any>();

  const hasAttachableTasks = useMemo(
    () =>
      type === 'patient' ||
      type === 'employee' ||
      type === 'cned' ||
      type === 'csc',
    [type]
  );

  useEffect(() => {
    const selectPatient = { ...selectedPatient };
    delete selectPatient.completed;
    if (selectedPatient) {
      setActualPatientData(selectPatient);
    }
  }, [selectedPatient]);

  return (
    <StickyFooter id="Round-Footer">
      <div className="me-4">
        <CompleteRoundBtn isEdit={isEdit} hasChanges={hasChanges} type={type} />
        <CancelRoundBtn isEdit={isEdit} type={type} />
      </div>
      {hasAttachableTasks && (
        <div className="me-2">
          <AddIssueFromRound
            modalData={
              type === 'patient'
                ? actualPatientData
                : { ...selectedEmployee, department: selectedEmployee?.dept }
            }
            type={type}
          />
          <AddFbFromRoundBtn
            modalData={
              type === 'patient' ? actualPatientData : selectedEmployee
            }
            type={type}
          />
        </div>
      )}
    </StickyFooter>
  );
};

export default RoundFooter;
